import { Storage } from '@ionic/storage';
import { AxiosInstance } from 'axios';
import { createContext, useCallback, useEffect, useState } from 'react';
import { authenticatedFetch } from '../services/api/api.service';
import { createStore } from '../services/ionic-storage';

export interface AppContextInterface {
  appStorage?: Storage | null;
  apiService?: AxiosInstance | null;
  isLoading: boolean;
  user?: any;
  login: (user: any, token: string) => void;
  updateUser: (user: any) => void;
  logout: () => void;
}

const initialState: AppContextInterface = {
  appStorage: null,
  apiService: null,
  isLoading: true,
  user: null,
  login: (user: any, token: string) => {
    return user;
  },
  updateUser: (user: any) => {
    return user;
  },
  logout: () => {},
};

export const AppContext = createContext({} as AppContextInterface);

const AppProvider = (props: any) => {
  const [appState, setAppState] = useState<AppContextInterface>(initialState);

  const getData = useCallback(async () => {
    const _storage = await createStore();
    initialState.appStorage = _storage;

    const apiService = await authenticatedFetch(initialState.appStorage);
    initialState.apiService = apiService;

    initialState.isLoading = false;
    initialState.user = await initialState.appStorage.get('user');
    initialState.updateUser = async (user: any) => {
      await initialState.appStorage?.set('user', user);
      setAppState({ ...appState, user });
    };
    initialState.login = async (user: any, token: any) => {
      await initialState.appStorage?.set('token', token);
      await initialState.appStorage?.set('user', user);
      const apiService = await authenticatedFetch(initialState.appStorage);
      initialState.apiService = apiService;
      setAppState({ ...appState, user });
    };
    initialState.logout = async () => {
      await initialState.appStorage?.remove('token');
      await initialState.appStorage?.clear();
      const apiService = await authenticatedFetch(null);
      appState.apiService = apiService;
      setAppState({ ...appState, user: null });
    };

    setAppState({ ...initialState });
  }, []);

  useEffect(() => {
    getData();
  }, []);

  return (
    <AppContext.Provider value={appState}>{props.children}</AppContext.Provider>
  );
};

export default AppProvider;
